import {
  BellRing,
  HelpCircle,
  MailCheck,
  MessageCircle,
  Plus,
  UserCheck,
} from "@tamagui/lucide-icons";
import type React from "react";
import { View, XStack, YStack } from "tamagui";
import { Body } from "../../ui/Body";
import { Box } from "../../ui/Box";
import { Group } from "../../ui/Group";
import type { IconProp } from "../../ui/icons";
import { Title } from "../../ui/Title";

const usps: { icon: IconProp; usp: string }[] = [
  {
    icon: MessageCircle,
    usp: "With Planira all discussions will be centered and focused around a topic automatically",
  },
  {
    icon: UserCheck,
    usp: "Create polls and rate options, discuss and decide together as a group",
  },
  {
    icon: Plus,
    usp: "No registration, all you need is an invite to get started",
  },
  {
    icon: BellRing,
    usp: "Easily see and track any activity to stay up to date",
  },
  {
    icon: MailCheck,
    usp: "Receive curated email updates to never miss out on an update or reminder",
  },
];

export const PlaniraUsps: React.FC = () => {
  return (
    <Box>
      <YStack gap="$larger">
        <XStack gap="$medium" alignItems="center">
          <HelpCircle />
          <Title>What's Planira?</Title>
        </XStack>

        <Group>
          {usps.map((usp, i) => {
            const Icon = usp.icon;
            return (
              <XStack key={`usp_${i}`} gap="$space.medium">
                <View minWidth={"$small"}>
                  <Icon size={"$small"} />
                </View>
                <Body>{usp.usp}</Body>
              </XStack>
            );
          })}
        </Group>
      </YStack>
    </Box>
  );
};
